async function verifyAssignedStores($axios, $auth) {
  let hasStores = false
  try {
    const result = await $axios.$get('user/stores')
    hasStores = Array.isArray(result?.value) && result.value.length > 0
  } catch (e) {
    hasStores = false
  }

  if (!hasStores) {
    try {
      await $auth.logout()
    } catch (e) {
      // the session is unusable without stores anyway; the caller shows the error
    }
  }

  return hasStores
}

module.exports = { verifyAssignedStores }
